import { useGetCompanies } from '@services/companies'
import {
  ChargingPointDetailStatusColor,
  EStatusPill,
  IChargingPoint,
} from '@services/device'
import { Empty } from 'antd'
import cx from 'classnames'

type IParkingSpaceProps = {
  onClick?: () => void
  data?: IChargingPoint
}

const ParkingSpace = (props: IParkingSpaceProps) => {
  const { onClick, data } = props
  const { byId: orgSessionById } = useGetCompanies()
  return data ? (
    <div
      className={cx('flex flex-col', {
        'cursor-pointer': !!onClick,
      })}
      onClick={() => onClick && onClick()}>
      <div className="w-64 h-48 flex-row-reverse flex">
        {data.connectors
          ?.sort((a, b) => (a.connectorId ?? 0) - (b.connectorId ?? 0))
          ?.map((connector, index) => {
            let backgroundColor =
              ChargingPointDetailStatusColor[
                connector.detailedStatus || 'Unavailable'
              ]
            if (
              connector.detailedStatus === EStatusPill.Finishing &&
              (connector.chargingPercentage ?? 0) < 100
            ) {
              backgroundColor = '#e0ae00'
            }
            return (
              <div
                key={connector.id}
                style={{
                  backgroundColor,
                }}
                className={cx(
                  'flex-1 border border-white inline-block',
                  {}
                )}></div>
            )
          })}
      </div>
      <div className="h-24 w-full border border-white text-white text-center text-base">
        {data.displayName}
      </div>
    </div>
  ) : (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="無充電樁資訊" />
  )
}

export default ParkingSpace
